import { FC } from 'react';
import { Button, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Auth } from 'aws-amplify';
import AuthLayout from 'layouts/AuthLayout';

const handleGoogleSignIn = () => {
  // Redirects to the Cognito Hosted UI, which federates to Google.
  Auth.federatedSignIn({ provider: 'Google' as never });
};

// Basic auth (email/password) is deprecated on the data tool — Google SSO only.
const SignIn: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AuthLayout title='Dismantly Data' isMobile={isMobile}>
      <Button
        fullWidth
        size='large'
        variant='contained'
        onClick={handleGoogleSignIn}
        sx={{ mt: 2, mb: 1, textTransform: 'none' }}
      >
        Sign in with Google
      </Button>
      <Typography variant='body2' color='text.secondary' align='center' sx={{ mt: 1 }}>
        Use your Dismantly Google account to continue.
      </Typography>
    </AuthLayout>
  );
};

export default SignIn;
